import React, {useState} from 'react'
import {activateAd, activateOrPauseAdSet, createAd, pauseAd} from "../../services/facebook-ads-service";
import {saveSingleAd} from "../../services/facebook-ad-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {saveSingleAdSet} from "../../services/facebook-ad-set-data.service";

const EditFacebookAdSet = ({adSet, afterCreateOrEditAdSetAction}) => {
    const [saveInProgress, setSaveInProgress] = useState(false);

    const activateFacebookAdSet = async () => {
        setSaveInProgress(true);

        adSet.status = 'ACTIVE';
        let today = new Date();
        // adSet.start_time = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

        await activateOrPauseAdSet(adSet);
        await saveSingleAdSet(adSet);

        setSaveInProgress(false);
        afterCreateOrEditAdSetAction();
    }

    const pauseFacebookAdSet = async () => {
        setSaveInProgress(true);

        adSet.status = 'PAUSED';
        // delete adSet.start_time;

        await activateOrPauseAdSet(adSet);
        await saveSingleAdSet(adSet);

        setSaveInProgress(false);
        afterCreateOrEditAdSetAction();
    }

    return (
        <>
            {adSet &&
                <div className="flex items-center justify-end mr-2">
                    <div className="">
                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                    </div>

                    {adSet.status === 'PAUSED' && !saveInProgress &&
                        <button
                            onClick={activateFacebookAdSet}
                            className="button-sky px-2 py-1">
                            Activate Ad Set
                        </button>
                    }

                    {adSet.status === 'ACTIVE' && !saveInProgress &&
                        <button
                            onClick={pauseFacebookAdSet}
                            className="button-outline-red px-2 py-1">
                            Pause Ad Set
                        </button>
                    }
                </div>
            }
        </>
    )
}

export default EditFacebookAdSet
